import type { ToastContainerOptions } from 'vue3-toastify';
import { defineNuxtPlugin } from 'nuxt/app';
import Vue3Toastify, { toast } from 'vue3-toastify';
// import 'vue3-toastify/dist/index.css';

export default defineNuxtPlugin((_nuxtApp) => {
	_nuxtApp.vueApp.use(Vue3Toastify, {
		autoClose: 3000,
		position: 'bottom-center',
		clearOnUrlChange: false,
		limit: 3,
	} as ToastContainerOptions);

	return {
		provide: {
			toast,
		},
	};
});
